import { isString } from "lodash";
import i18n from "src/locales/i18n";
import { BusinessErrorCodes } from "src/types/business-errors";


export const generateMeetingCreateError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.UnsupportedMeetingPlatform) {
      return i18n.t('meetings.api.create.unsupported_platform');
    }

  }
  return i18n.t('meetings.api.create.default_error');
};


export const generateMeetingUpdateError = (e: any) => {
  if (isString(e?.data?.error_code)) {
    if (e?.data.error_code === BusinessErrorCodes.UnsupportedMeetingPlatform) {
      return i18n.t('meetings.api.update.unsupported_platform');
    }

  }
  return i18n.t('meetings.api.update.default_error');
};